import { Draft, DraftConfigurationWithText } from '@/types';
import { isDraftConfigurationWithText } from '@/model/configuration/isDraftConfigurationType';
import { getViewId } from '@/model/printArea/getViewId';
import { getConfigurations } from './getConfigurations';

export function getLastTextConfiguration(draft: Draft): DraftConfigurationWithText | undefined {
  const textConfigurations = getConfigurations(draft).filter(isDraftConfigurationWithText);
  if (textConfigurations.length < 2) {
    return textConfigurations[0];
  }

  const currentViewId = draft.view.id;
  const textConfigurationsOnView = textConfigurations.filter(
    ({ printArea }) => getViewId(printArea) === currentViewId
  );
  const possibleConfigurations =
    textConfigurationsOnView.length > 0 ? textConfigurationsOnView : textConfigurations;

  const configurationIds = draft.configurationIds;
  const topMostCidIndex = Math.max(
    ...possibleConfigurations.map(({ cid }) => configurationIds.indexOf(cid))
  );
  const topMostCid = configurationIds[topMostCidIndex];
  return possibleConfigurations.find(({ cid }) => cid === topMostCid);
}
